<template>
  <div class="ai-drug-check-status">
    <div class="ai-drug-check-status-pill" v-if="loading">
      <div class="loading" />
      <span>Checagem de medicamentos...</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.ai-drug-check-status {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;

  .ai-drug-check-status-pill {
    align-items: center;
    background-color: lighten($info-color, 48%);
    border: $border-width solid lighten($info-color, 34%);
    border-radius: 1rem;
    color: darken($info-color, 10%);
    display: flex;
    font-size: $font-size-sm;
    gap: $layout-spacing;
    padding: $unit-1 $layout-spacing-lg;
  }

  .loading {
    margin: 0;
    min-height: $unit-3;
    width: $unit-3;
    &::after {
      border-color: $info-color;
      border-right-color: transparent;
      border-top-color: transparent;
      height: $unit-3;
      margin-left: -$unit-3 * .5;
      margin-top: -$unit-3 * .5;
      width: $unit-3;
    }
  }
}
</style>
